/**
 * 記事詳細ページでつかわれる
 */

export default class SinglePage {
   constructor() {
      this.youtubeIframeResponsible()
   }

   // YouTube埋め込みがあったときにレスポンシブにする
   youtubeIframeResponsible() {
      if ($('.js-detect-youtube-responsive-target iframe').length) {
         $('.js-detect-youtube-responsive-target iframe').each((i, el) => {
            if ($(el).attr('src').indexOf('youtube') != -1) {
               $(el).parent('p').addClass('c-youtube');
            }
         })
      }
   }
};

